import { NavLink } from "react-router-dom";
import { Box, Button, Container, Typography, Grid } from "@mui/material";

// Components
import Footer from "../components/Footer";
import MissionVision from "../components/MissionVision";
import Testimonials from "../components/Testimonials";
import WhySchool from "../components/WhySchool";
import UndergraduatePrograms from "./UndergraduatePrograms";
import { AppName } from "../constants";
import About from "./About";
import AboutInfo from "../components/AboutInfo";
import AboutParts from "../components/AboutParts";
import QuranicPrograms from "./QuranicPrograms";
import HeroBannerCarousel from "../components/HeroBannerCarousel";
import AllPrograms from "./AllPrograms";

import image6 from "../assets/quran_images.jpg";

const Home = () => {
    return (
        <>
            {/* Hero Section */}
            {/* <Box
                sx={{
                    position: 'relative',
                    backgroundImage: 'url(/images/image1.jpg)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    color: 'white',
                    py: 10,
                    textAlign: 'center',
                    overflow: 'hidden',
                    '::before': {
                        content: '""',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)', // black tint with 50% opacity
                        zIndex: 1,
                    },
                    // Ensure content is above the overlay
                    position: 'relative',
                    zIndex: 2,
                }}
            >
                <Box sx={{ position: 'relative', zIndex: 2 }}>
                    <Container maxWidth="md">
                        <Typography variant="h3" component="h1" gutterBottom fontWeight="bold">
                            Welcome to {AppName}
                        </Typography>
                        <Typography variant="h6" sx={{ mb: 4 }}>
                            A place where knowledge thrives, dreams soar, and friendships flourish.
                        </Typography>
                        <Button
                            variant="contained"
                            color="secondary"
                            size="large"
                            component={NavLink}
                            to="/about"
                        >
                            Explore
                        </Button>
                    </Container>
                </Box>
            </Box> */}
            <HeroBannerCarousel/>
            {/* Mission & Vision Section */}
            <Container>
                <Box sx={{ margin:"0 auto",py: 8, backgroundColor: "#f9f9f9" }}>
                    
                    <Grid container spacing={4} sx={{ mt: 4 }}>

                        <Grid item  xs={12} sm={6} md={4}>
                            <Container>
                                <div className="about-info">
                                    <div className="vc-image">
                                    <img src={image6} alt="Wise Kidz" />
                                    </div>
                                    <div className="vc-office">
                                    <h1>Welcome to Wise Kidz</h1>
                                    <blockquote style={{ fontStyle: 'italic', marginBottom: '1.5rem' }}>
                                        “Education is the passport to the future, for tomorrow belongs to those who prepare for it today.”<br />
                                        <span style={{ fontWeight: 'bold' }}>– Malcolm X</span>, a human rights activist of the civil rights movement and an American Muslim minister.
                                    </blockquote>

                                    <h2>What We Do</h2>

                                    <h3>Empowering Young Minds</h3>
                                    <p>We teach kids to think critically, not just follow instructions.</p>

                                    <h3>Logic Over Memorization</h3>
                                    <p>Our curriculum is built on common sense, argument, and real understanding.</p>

                                    <h3>Curiosity is the Curriculum</h3>
                                    <p>We spark questions, not just give answers.</p>

                                    <h3>Think. Reason. Grow.</h3>
                                    <p>Wise Kidz helps children become thoughtful, independent learners.</p>

                                    <h3>Teaching with Purpose</h3>
                                    <p>We value critical thinking over the blind following.</p>
                                    </div>
                                </div>
                                </Container>
                        </Grid>
                        <Grid item  xs={12} sm={6} md={4}>
                            
                        </Grid>
                        <Grid item  xs={12} sm={6} md={4}>
                            
                        </Grid>

                    </Grid>
                    
                </Box>
            </Container>
            {/* Quranic Programs Section */}
            <Box sx={{ py: 8 }}>
                <Container>
                    <AllPrograms type={"quranic"} title={"Islamic"} subtitle={"Courses"} />
                    <AllPrograms type={"undergraduate"}  title={"Academic"} subtitle={"Tutoring"} />
                    <AllPrograms type={"test"}  title={"Test"} subtitle={"Preparation"} />
                </Container>
            </Box>
            
            {/* Why School Section */}
            <Box sx={{ py: 8, backgroundColor: "#f9f9f9" }}>
                <Container>
                    <WhySchool />
                </Container>
            </Box>

            {/* Testimonials Section */}
            <Box sx={{ py: 8 }}>
                <Container>
                    <Testimonials />
                </Container>
            </Box>

            {/* Footer */}
            <Footer />
        </>
    );
};

export default Home;
